import { httpClient } from './http-client';
import { API_ENDPOINTS } from '../config/api';

export interface FeedingAreaItem {
  id: number;
  name: string;
  manager: string;
  phoneNumber: string;
  regionId?: number | null;
  region?: { id: number; nameRu: string; nameKz: string; nameEn: string } | null;
  accountNumber: string;
  productionCapacity: number;
  occupancyPercentage: number;
  iinBin?: string | null;
  notes?: string | null;
  isActive: boolean;
  isEasu: boolean;
  latitude?: number | null;
  longitude?: number | null;
  createdAt: string;
  updatedAt?: string | null;
}

export interface CreateFeedingAreaRequest {
  name: string;
  manager: string;
  phoneNumber: string;
  regionId?: number | null;
  accountNumber: string;
  productionCapacity: number;
  occupancyPercentage: number;
  iinBin?: string | null;
  notes?: string | null;
  isActive: boolean;
  isEasu: boolean;
  latitude?: number | null;
  longitude?: number | null;
}

const BASE = API_ENDPOINTS.FEEDING_AREA;

export const feedingAreaService = {
  getAll(isActive?: boolean, regionId?: number) {
    const params = new URLSearchParams();
    if (isActive !== undefined) params.set('isActive', String(isActive));
    if (regionId !== undefined) params.set('regionId', String(regionId));
    const qs = params.toString();
    return httpClient.get<FeedingAreaItem[]>(BASE + (qs ? `?${qs}` : ''));
  },

  getById(id: number) {
    return httpClient.get<FeedingAreaItem>(`${BASE}/${id}`);
  },

  create(body: CreateFeedingAreaRequest) {
    return httpClient.post<FeedingAreaItem>(BASE, body);
  },

  update(id: number, body: CreateFeedingAreaRequest) {
    return httpClient.put<FeedingAreaItem>(`${BASE}/${id}`, body);
  },

  delete(id: number) {
    return httpClient.delete(`${BASE}/${id}`);
  },
};
